function initializeProductVideoAutoplay() {
    const deferredMediaElements = document.querySelectorAll('deferred-media[data-media-id]');

    // Autoplay videos on desktop
    deferredMediaElements.forEach(deferredMedia => {
        // Create a mutation observer to detect when the video element is added to the DOM
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                const videoEl = deferredMedia.querySelector('video');
                if (videoEl) {
                videoEl.addEventListener('play', () => {
                    videoEl.dataset.isPlaying = 'true';
                });
                
                // Use Intersection Observer to detect when video becomes visible
                const videoObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                    if (entry.isIntersecting && videoEl.paused && videoEl.dataset.isPlaying !== 'false') {
                        videoEl.play().catch(e => console.error('Error playing video:', e));
                    }
                    });
                }, { threshold: 0.1 });
                
                videoObserver.observe(videoEl);
                observer.disconnect();
                }
            }
            });
        });
        observer.observe(deferredMedia, { childList: true, subtree: true });
    });

    // Autoplay videos on mobile
    deferredMediaElements.forEach(deferredMedia => {
        if (!deferredMedia.hasAttribute('loaded')) {
            deferredMedia.loadContent(false);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initializeProductVideoAutoplay();
});
